import { Box } from '@mui/material'
import Lottie from 'lottie-react'
import Loading from '../assets/animations/Loading.json'

const Loader = () => {
  return (
    <Box
      height={'100%'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Lottie
        animationData={Loading}
        loop
        style={{ height: '400px', width: '200px' }}
      />
    </Box>
  )
}

export default Loader
